import { Component,  OnInit, ViewChild,  ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  searchByName=''
  searchVal=null
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Technology", prop: "technology" },
    { name: "Category", prop: "category" },
    { name: "Notes", prop: "notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;

  channel_id:any
  isActivated:boolean
  @ViewChild('name') inputName;
  user_role:any

  guideline_data:any
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
             private spinner: NgxSpinnerService,  
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session: SessionStorageService,
              private router:Router,private activatedRoute : ActivatedRoute,
              private store: Store<AppState>) {
              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key == 'Channel') 
              this.guideline_data = key_data[0]?._id

              this.activatedRoute.queryParamMap.subscribe((params) => {
                let page = +params.get('page');
                this.setPage(page)
              });
              this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
              .subscribe(pageNumber => {
                this.page.pageNumber = pageNumber;
                if(pageNumber !==undefined){
                  this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                }
              });

              }

  ngOnInit(): void {
    this.getAllChannel()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }

  getAllChannel(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllChannels(this.page.pageNumber +1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows =res.items
      this.page.totalPages=res.total
    })
  }
  pageChangeData(page:any) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.apiService.getAllChannels(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.setPage(page.offset +1)
      this.rows =res.items
      this.page.totalPages=res.data.total
    }) 
  }

  resetFilter(){
    this.inputName.nativeElement.value=null
    this.getAllChannel()
  }

 
  editChannel(row) {
    this.session.setObject('channel-data', row)
    this.router.navigate(['channel/edit'])
  }
  deleteBusiness(){
    if(this.channel_id){
      this.apiService.deleteChannel(this.channel_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getAllChannel()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }

   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.channel_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteBusiness()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
 
}

